import React from 'react';
import { Link } from 'react-router-dom';
import './AboutBanner.scss';
import bannerOne from '../../assets/about/banner/banner_1.png'
import bannerTwo from '../../assets/about/banner/banner_2.png'
import pattern from '../../assets/banner/pattern.png'

const AboutBanner = () => {
    return (
        <section className='about-section'>
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5">
                                <div className="about-banner-text">
                                    <h2>About TRUECARE</h2>
                                    <p>Welcome to TRUECARE DENTAL & IMPLANT CENTER, Yamunanagar's premier dental practice. Led by Dr. Vinamrata (MDS from Govt. Dental College, Ahmedabad), we provide comprehensive dental care with advanced equipment and hygienic practices. Our mission is to ensure every patient receives expert care in a comfortable, modern environment.</p>
                                    
                                    <div className="clinic-highlights">
                                        <div className="highlight-item">
                                            <span className="highlight-icon">👩‍⚕️</span>
                                            <div className="highlight-text">
                                                <h4>Expert MDS Specialist</h4>
                                                <p>Dr. Vinamrata brings years of expertise from prestigious institutions</p>
                                            </div>
                                        </div>
                                        <div className="highlight-item">
                                            <span className="highlight-icon">🦷</span>
                                            <div className="highlight-text">
                                                <h4>Advanced Equipment</h4>
                                                <p>State-of-the-art dental technology for precise treatments</p>
                                            </div>
                                        </div>
                                        <div className="highlight-item">
                                            <span className="highlight-icon">🏥</span>
                                            <div className="highlight-text">
                                                <h4>Hygienic Care</h4>
                                                <p>Sterilized environment following international standards</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="theme-btn">
                                        <Link to='/contact'>Contact Us</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="about-banner-img">
                                    <img src={bannerOne} alt="about banner"/>
                                    <img src={bannerTwo} alt="about banner two"/>
                                    <img className='pattern' src={pattern} alt="about banner two"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutBanner;